// Axios
import { _axios } from "../../Base_Axios_Config/_axios";
import { AxiosResponse } from "axios";
// Axios

// Models
import { I_SendingCallOfRegistrationRequest } from "../../../Models/sendingDataSchema";
import {
  I_Message,
  I_RecevedSingleCallOfRegistrationRequestsData,
} from "../../../Models/interfaces";
// Models

export const getAllRequestForSingleCallOfRegistrationService = async (_data: {
  userToken: string;
  _data: I_SendingCallOfRegistrationRequest;
}): Promise<
  AxiosResponse<{
    error: number;
    messages: I_Message[];
    result: I_RecevedSingleCallOfRegistrationRequestsData;
  }>
> => {
  return _axios.get(
    `/call-of-registrations/requests?page=${_data._data.page}&size=${_data._data.size}&tenant=${_data._data.tenant}&callOfRegistrationId=${_data._data.callOfRegistrationId}&state=${_data._data.state}&search=${_data._data.search}`,
    {
      headers: {
        Authorization: `Bearer ${_data.userToken}`,
      },
    }
  );
};
